<p-dropdown
        [options]="options"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        [showClear]="true"
        [filter]="true"
        appendTo="body"
        [style]="{ width: '100%' }"
        [virtualScroll]="true"
        [virtualScrollItemSize]="20"
>
    <ng-template let-item pTemplate="item">
        <div>{{ item?.[optionLabel] || '' }}</div>
    </ng-template>
</p-dropdown>